var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "grid-view" },
      [
        _c("div", { staticClass: "main-content" }, [
          _c("div", { staticClass: "section" }, [
            !_vm.isView
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "1" },
                        on: { click: _vm.cancelSave }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          no: "2",
                          disabled: _vm.btnSaveEnable
                        },
                        on: { click: _vm.saveBillingGroupDetail }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              [
                _vm.isView
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "3", type: "primary" },
                        on: { click: _vm.backEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.$checkPermission(["button_ACTBilling_editBillingGroup"]) &&
                !_vm.hasAgentBilling
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "4", type: "primary" },
                        on: { click: _vm.editBillingGroup }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.billingGroup &&
                _vm.billingGroup.uuid &&
                _vm.$checkPermission([
                  "button_ACTBilling_createInvoiceFromBillingGroup"
                ]) &&
                !_vm.hasAgentBilling
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "5", type: "primary" },
                        on: { click: _vm.makeInvoiceEvent }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            !_vm.billingGroup.ar
                              ? _vm.$t("CargoMsg.Cargo_CollectInvoice")
                              : _vm.$t("CargoMsg.Cargo_Invoicing")
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.billingGroup &&
                _vm.billingGroup.uuid &&
                _vm.$checkPermission(["button_ACTBilling_writeoffBillingGroup"])
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "6", type: "primary" },
                        on: { click: _vm.writeoffHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("Billing.billingView_writeOff")))]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.billingGroup &&
                _vm.billingGroup.uuid &&
                !_vm.billingGroup.ar &&
                _vm.$checkPermission([
                  "button_ACTBilling_payauthBillingGroup"
                ]) &&
                !_vm.hasAgentBilling
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "7", type: "primary" },
                        on: { click: _vm.doBillPayment }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ApplyForPayment")))]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.billingGroup &&
                _vm.billingGroup.uuid &&
                !_vm.hasAgentBilling
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "8", type: "primary" },
                        on: { click: _vm.printEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.expandedGrid,
                  expression: "!expandedGrid"
                }
              ],
              staticClass: "main-content",
              staticStyle: { "flex-grow": "unset", "margin-bottom": "5px" }
            },
            [
              _c(
                "el-form",
                {
                  ref: "basicForm",
                  attrs: {
                    "label-position": "left",
                    "label-width": "110px",
                    model: _vm.billingGroup
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", gutter: 5 } },
                    [
                      _c(
                        "el-col",
                        { staticStyle: { width: "550px" }, attrs: { span: 7 } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "section",
                              staticStyle: { height: "100%" }
                            },
                            [
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_AccountStatementNo"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: true, no: "9" },
                                        model: {
                                          value: _vm.billingGroup.billingNo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billingGroup,
                                              "billingNo",
                                              $$v
                                            )
                                          },
                                          expression: "billingGroup.billingNo"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_DateOfDocument"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          no: "10",
                                          type: "date",
                                          clearable: "",
                                          disabled: _vm.isView
                                        },
                                        on: { change: _vm.inputDateChange },
                                        model: {
                                          value: _vm.billingGroup.inputDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billingGroup,
                                              "inputDate",
                                              $$v
                                            )
                                          },
                                          expression: "billingGroup.inputDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_InvoiceTitle"
                                        )
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "11",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .static_data_Title,
                                          "allow-create":
                                            !_vm.arSettlementUnitOptional ||
                                            !_vm.billingGroup.ar,
                                          filterable: "",
                                          cache: false,
                                          disabled: _vm.isView,
                                          "default-value":
                                            _vm.billingGroup.title,
                                          "static-options": _vm.titleArray
                                        },
                                        on: {
                                          parentCallBack: _vm.titleChangeEvent
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_RegistrationAddress"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: _vm.isView,
                                          no: "12"
                                        },
                                        model: {
                                          value: _vm.billingGroup.buyerAddress,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billingGroup,
                                              "buyerAddress",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "billingGroup.buyerAddress"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_RegistrationNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { disabled: true, no: "13" },
                                            model: {
                                              value:
                                                _vm.billingGroup
                                                  .buyerTaxAccount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billingGroup,
                                                  "buyerTaxAccount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billingGroup.buyerTaxAccount"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("CargoMsg.Cargo_Tel")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "152px" },
                                            attrs: {
                                              disabled: _vm.isView,
                                              no: "14"
                                            },
                                            model: {
                                              value:
                                                _vm.billingGroup.buyerTelephone,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billingGroup,
                                                  "buyerTelephone",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billingGroup.buyerTelephone"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_DepositBank"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-advance-select", {
                                            attrs: {
                                              no: "15",
                                              filterable: "",
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .static_data_TitleBank,
                                              "default-value":
                                                _vm.billingGroup.buyerBank,
                                              disabled: _vm.isView,
                                              cache: false,
                                              "tag-value": "bank",
                                              "static-options":
                                                _vm.titleBankArray
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.getBankCusFromChild
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_AccountNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "152px" },
                                            attrs: { disabled: true, no: "16" },
                                            model: {
                                              value:
                                                _vm.billingGroup
                                                  .buyerBankAccount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billingGroup,
                                                  "buyerBankAccount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billingGroup.buyerBankAccount"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_RevenueAndExpenditureType"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: true,
                                              value: _vm.billingGroup.ar
                                                ? _vm.$t(
                                                    "CargoMsg.Cargo_Receivable"
                                                  )
                                                : _vm.$t("CargoMsg.Cargo_Dues"),
                                              no: "17"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_Amount"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticStyle: { width: "152px" },
                                            attrs: {
                                              disabled: true,
                                              precision: 2,
                                              controls: false,
                                              no: "18"
                                            },
                                            model: {
                                              value: _vm.billingGroup.amount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billingGroup,
                                                  "amount",
                                                  $$v
                                                )
                                              },
                                              expression: "billingGroup.amount"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_SettleAccountsTo"
                                        )
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "19",
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Company,
                                          "method-params": {
                                            auto_accountId: true
                                          },
                                          "callback-method-type": "value",
                                          "default-value": Number(
                                            _vm.billingGroup.accountId
                                          ),
                                          "tag-name":
                                            this.$store.getters.language ===
                                            "zh"
                                              ? "chineseName"
                                              : "englishName",
                                          disabled: true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_InvoicingRequirements"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: _vm.isView,
                                          no: "20"
                                        },
                                        model: {
                                          value: _vm.billingGroup.invoiceDemand,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billingGroup,
                                              "invoiceDemand",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "billingGroup.invoiceDemand"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_OwnerBankOfDeposit"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-advance-select", {
                                            attrs: {
                                              no: "21",
                                              filterable: "",
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .static_data_BankAccount,
                                              cache: false,
                                              "default-value": Number(
                                                _vm.billingGroup.bankAccountId
                                              ),
                                              disabled: _vm.isView,
                                              "static-options":
                                                _vm.ourBankAccountArray
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.getOurBankAccountFromChild
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_AccountNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "152px" },
                                            attrs: { disabled: true, no: "22" },
                                            model: {
                                              value: _vm.ourBankAccountNo,
                                              callback: function($$v) {
                                                _vm.ourBankAccountNo = $$v
                                              },
                                              expression: "ourBankAccountNo"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_TotalCurrency"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: true, no: "23" },
                                        model: {
                                          value:
                                            _vm.billingGroup.currencyAmount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billingGroup,
                                              "currencyAmount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "billingGroup.currencyAmount"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "Billing.billingJob_otherPartyBilling"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: _vm.isView,
                                          no: "24"
                                        },
                                        model: {
                                          value:
                                            _vm.billingGroup.otherPartyBilling,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billingGroup,
                                              "otherPartyBilling",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "billingGroup.otherPartyBilling"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            "padding-left": "5px",
                            flex: "1",
                            height: "auto"
                          },
                          attrs: { span: 17 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "section",
                              staticStyle: { height: "100%" }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c(
                                    "el-col",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.billingGroup.billingType ===
                                            "国内账单",
                                          expression:
                                            "billingGroup.billingType === '国内账单'"
                                        }
                                      ]
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "Invoice.invoice_invoiceCategory"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                no: "26",
                                                placeholder: _vm.isView
                                                  ? ""
                                                  : _vm.$t(
                                                      "CargoMsg.Cargo_PleaseSelect"
                                                    ),
                                                disabled: _vm.isView,
                                                clearable: ""
                                              },
                                              on: {
                                                change:
                                                  _vm.changeInvoiceMakeType
                                              },
                                              model: {
                                                value:
                                                  _vm.billingGroup
                                                    .invoiceMakeType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billingGroup,
                                                    "invoiceMakeType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billingGroup.invoiceMakeType"
                                              }
                                            },
                                            _vm._l(
                                              _vm.invoiceMakeTypes,
                                              function(item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.chineseName,
                                                    value: item.code
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.billingGroup.billingType ===
                                            "国内账单",
                                          expression:
                                            "billingGroup.billingType === '国内账单'"
                                        }
                                      ]
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_InvoiceType"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                disabled: _vm.isView,
                                                no: "25",
                                                placeholder: _vm.isView
                                                  ? ""
                                                  : _vm.$t(
                                                      "CargoMsg.Cargo_PleaseSelect"
                                                    ),
                                                clearable: ""
                                              },
                                              model: {
                                                value:
                                                  _vm.billingGroup.invoiceType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billingGroup,
                                                    "invoiceType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billingGroup.invoiceType"
                                              }
                                            },
                                            _vm._l(_vm.invoiceTypes, function(
                                              item,
                                              index
                                            ) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label: item.chineseName,
                                                  value: item.code
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_InvoicingAddress"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          no: "27",
                                          rows: 7,
                                          disabled: _vm.isView
                                        },
                                        model: {
                                          value:
                                            _vm.billingGroup.billingAddress,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billingGroup,
                                              "billingAddress",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "billingGroup.billingAddress"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("CargoMsg.Cargo_Remarks")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          no: "28",
                                          rows: 7,
                                          disabled: _vm.isView
                                        },
                                        model: {
                                          value: _vm.billingGroup.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billingGroup,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "billingGroup.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "Invoice.invoice_invoiceRemarks"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          no: "29",
                                          rows: 6,
                                          disabled: _vm.isView
                                        },
                                        model: {
                                          value: _vm.billingGroup.invoiceRemark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billingGroup,
                                              "invoiceRemark",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "billingGroup.invoiceRemark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section", staticStyle: { "text-align": "center" } },
            [
              _c("i", {
                class: _vm.expandedGrid
                  ? "el-icon-caret-bottom"
                  : "el-icon-caret-top",
                on: {
                  click: function($event) {
                    _vm.expandedGrid = !_vm.expandedGrid
                  }
                }
              })
            ]
          ),
          _c(
            "div",
            { staticClass: "tabs-container" },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Bill"),
                        name: "bill",
                        lazy: true
                      }
                    },
                    [
                      _c("div", { staticClass: "section" }, [
                        !_vm.isView
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", no: "30" },
                                    on: { click: _vm.addBilling }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_JoinBill"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", no: "31" },
                                    on: { click: _vm.removeBilling }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_DeleteBill")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "grid-wrapper",
                            staticStyle: { "margin-top": "10px" }
                          },
                          [
                            _c("cargo-ag-grid", {
                              style: { width: "100%" },
                              attrs: {
                                "config-module": "190908",
                                "grid-options": _vm.billingGridOptions,
                                "column-defs": _vm.billingColumnDefs,
                                "grid-params": _vm.billingGridParams,
                                "row-data": _vm.billingRowData
                              },
                              on: {
                                "update:gridParams": function($event) {
                                  _vm.billingGridParams = $event
                                },
                                "update:grid-params": function($event) {
                                  _vm.billingGridParams = $event
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm.billingGroup.uuid
                    ? _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Cost"),
                            name: "charge",
                            lazy: true
                          }
                        },
                        [
                          _c("div", { staticClass: "section" }, [
                            _c(
                              "div",
                              { staticClass: "section grid-wrapper" },
                              [
                                _c("cargo-ag-grid", {
                                  style: { width: "100%" },
                                  attrs: {
                                    "config-module": "190909",
                                    "grid-options": _vm.chargeGridOptions,
                                    "column-defs": _vm.chargeColumnDefs,
                                    "grid-params": _vm.chargeGridParams,
                                    "row-data": _vm.chargeRowData
                                  },
                                  on: {
                                    "update:gridParams": function($event) {
                                      _vm.chargeGridParams = $event
                                    },
                                    "update:grid-params": function($event) {
                                      _vm.chargeGridParams = $event
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "pagination-wrapper" },
                              [
                                _c("cargo-pagination", {
                                  attrs: {
                                    total: _vm.searchConditions.total,
                                    page: _vm.searchConditions.pageNum,
                                    limit: _vm.searchConditions.pageSize
                                  },
                                  on: {
                                    "update:page": function($event) {
                                      return _vm.$set(
                                        _vm.searchConditions,
                                        "pageNum",
                                        $event
                                      )
                                    },
                                    "update:limit": function($event) {
                                      return _vm.$set(
                                        _vm.searchConditions,
                                        "pageSize",
                                        $event
                                      )
                                    },
                                    pagination: _vm.fetchDataByPage
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.billingGroup.uuid
                    ? _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Business"),
                            name: "job",
                            lazy: true
                          }
                        },
                        [
                          _c("div", { staticClass: "section" }, [
                            _c(
                              "div",
                              { staticClass: "section grid-wrapper" },
                              [
                                _c("cargo-ag-grid", {
                                  style: { width: "100%" },
                                  attrs: {
                                    "config-module": "190910",
                                    "grid-options": _vm.jobGridOptions,
                                    "column-defs": _vm.jobColumnDefs,
                                    "grid-params": _vm.jobGridParams,
                                    "row-data": _vm.jobRowData
                                  },
                                  on: {
                                    "update:gridParams": function($event) {
                                      _vm.jobGridParams = $event
                                    },
                                    "update:grid-params": function($event) {
                                      _vm.jobGridParams = $event
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "pagination-wrapper" },
                              [
                                _c("cargo-pagination", {
                                  attrs: {
                                    total: _vm.searchConditions.total,
                                    page: _vm.searchConditions.pageNum,
                                    limit: _vm.searchConditions.pageSize
                                  },
                                  on: {
                                    "update:page": function($event) {
                                      return _vm.$set(
                                        _vm.searchConditions,
                                        "pageNum",
                                        $event
                                      )
                                    },
                                    "update:limit": function($event) {
                                      return _vm.$set(
                                        _vm.searchConditions,
                                        "pageSize",
                                        $event
                                      )
                                    },
                                    pagination: _vm.fetchDataByPage
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm.showJoinBillDialog
          ? _c("join-bill-dialog", {
              attrs: {
                visible: _vm.showJoinBillDialog,
                "add-billing-conditions": _vm.addBillingConditions,
                "only-has-agent-bill": _vm.addBillingConditions.onlyHasAgentBill
              },
              on: {
                "update:visible": function($event) {
                  _vm.showJoinBillDialog = $event
                },
                backBillingGroupDetail: _vm.backBillingGroupDetail
              }
            })
          : _vm._e(),
        _c("make-invoice-dialog", {
          ref: "invoice",
          attrs: { location: _vm.location, "view-source": "billGroupDetail" }
        }),
        _c("cargo-template-selector-dialog", {
          attrs: {
            visible: _vm.templateSelectorDialog.visible,
            ctx: _vm.templateSelectorDialog.cxt,
            category: _vm.templateSelectorDialog.category,
            data: _vm.templateSelectorDialog.data,
            "pre-print-callback": _vm.prePrintCallback
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
            }
          }
        }),
        _c("bill-payment-dialog", {
          ref: "billPayment",
          attrs: {
            visible: _vm.showBillPaymentDialog,
            "create-submit": true,
            location: _vm.location,
            step: "step2",
            mode: "overview"
          },
          on: {
            "update:visible": function($event) {
              _vm.showBillPaymentDialog = $event
            },
            cancel: _vm.cancelBillPayment
          }
        }),
        _vm.writeOffDialog.visible
          ? _c("write-off-dialog", {
              ref: "dgWriteoff",
              attrs: {
                location: _vm.location,
                visible: _vm.writeOffDialog.visible,
                title: _vm.title,
                properties: _vm.properties
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.writeOffDialog, "visible", $event)
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }